import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Loading, withQuery } from "components/common";
import IssuingTransactionsTable from "./components/IssuingTransactionsTable";

import { GET_ISSUING_TRANSACTIONS_QUERY, GET_ISSUING_TRANSACTIONS_NEXT } from "../gql";

const IssuingApprovedTransactions = ({ data: { pending, settled } = { } }) => {
  if (!pending && !settled) {
    return <Loading/>;
  }

  return (
    <IssuingTransactionsTable
      pending={pending.transactions}
      settled={settled.transactions}
      nextToken={settled.nextToken}
      activityQuery={GET_ISSUING_TRANSACTIONS_NEXT}
    />
  );
};

const mapStateToProps = (state) => ({
  roles: state.user.roles,
});

export default compose(
  connect(mapStateToProps),
  withQuery(GET_ISSUING_TRANSACTIONS_QUERY),
)(IssuingApprovedTransactions);